import { EmbeddedMode } from './modes/EmbeddedMode';
import { StandaloneMode } from './modes/StandaloneMode';

function App() {
  // Detecta si estamos dentro de un iframe comparando self con top
  const isEmbedded = window.self !== window.top;

  return isEmbedded ? <EmbeddedMode /> : <StandaloneMode />;
}

export default App;
